import React from 'react';
import { Tag, Space, Typography } from 'antd';
import { TagOutlined } from '@ant-design/icons';

const { Text } = Typography;

const RecipeTags = ({ tags }) => {
  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <Space direction="vertical" size="small" style={{ width: '100%' }}>
      <Text strong>
        <TagOutlined /> Tags:
      </Text>
      <Space wrap>
        {tags.map((tag, index) => (
          <Tag key={index} color="blue">
            {tag.name}
          </Tag>
        ))}
      </Space>
    </Space>
  );
};

export default RecipeTags;
